// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/jepx_settlement_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { BiddingBidMarket } from "./bidding_common_model_pb";
import { file_bffuser_v1_bidding_common_model } from "./bidding_common_model_pb";
import type { JepxSettlement, JepxSettlementSummary } from "./jepx_settlement_model_pb";
import { file_bffuser_v1_jepx_settlement_model } from "./jepx_settlement_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/jepx_settlement_service.proto.
 */
export const file_bffuser_v1_jepx_settlement_service: GenFile = /*@__PURE__*/
  fileDesc("CihiZmZ1c2VyL3YxL2plcHhfc2V0dGxlbWVudF9zZXJ2aWNlLnByb3RvEgpiZmZ1c2VyLnYxIrYBChpMaXN0SmVweFNldHRsZW1lbnRzUmVxdWVzdBI4CgZtYXJrZXQYASABKA4yHC5iZmZ1c2VyLnYxLkJpZGRpbmdCaWRNYXJrZXRCCrpIB4IBBBABIAASLwoUc2V0dGxlbWVudF9kYXRlX2Zyb20YAiABKAsyES5nb29nbGUudHlwZS5EYXRlEi0KEnNldHRsZW1lbnRfZGF0ZV90bxgDIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUibgobTGlzdEplcHhTZXR0bGVtZW50c1Jlc3BvbnNlEh4KFmplcHhfbWVtYmVyX3JlZ2lzdGVyZWQYASABKAgSLwoLc2V0dGxlbWVudHMYAiADKAsyGi5iZmZ1c2VyLnYxLkplcHhTZXR0bGVtZW50In8KH0dldEplcHhTZXR0bGVtZW50U3VtbWFyeVJlcXVlc3QSOAoGbWFya2V0GAEgASgOMhwuYmZmdXNlci52MS5CaWRkaW5nQmlkTWFya2V0Qgq6SAeCAQQQASAAEiIKEXNldHRsZW1lbnRfbnVtYmVyGAIgASgJQge6SARyAhABIlYKIEdldEplcHhTZXR0bGVtZW50U3VtbWFyeVJlc3BvbnNlEjIKB3N1bW1hcnkYASABKAsyIS5iZmZ1c2VyLnYxLkplcHhTZXR0bGVtZW50U3VtbWFyeSKAAQogRG93bmxvYWRKZXB4U2V0dGxlbWVudFBkZlJlcXVlc3QSOAoGbWFya2V0GAEgASgOMhwuYmZmdXNlci52MS5CaWRkaW5nQmlkTWFya2V0Qgq6SAeCAQQQASAAEiIKEXNldHRsZW1lbnRfbnVtYmVyGAIgASgJQge6SARyAhABIjQKIURvd25sb2FkSmVweFNldHRsZW1lbnRQZGZSZXNwb25zZRIPCgdjb250ZW50GAEgASgMMvACChVKZXB4U2V0dGxlbWVudFNlcnZpY2USZgoTTGlzdEplcHhTZXR0bGVtZW50cxImLmJmZnVzZXIudjEuTGlzdEplcHhTZXR0bGVtZW50c1JlcXVlc3QaJy5iZmZ1c2VyLnYxLkxpc3RKZXB4U2V0dGxlbWVudHNSZXNwb25zZRJ1ChhHZXRKZXB4U2V0dGxlbWVudFN1bW1hcnkSKy5iZmZ1c2VyLnYxLkdldEplcHhTZXR0bGVtZW50U3VtbWFyeVJlcXVlc3QaLC5iZmZ1c2VyLnYxLkdldEplcHhTZXR0bGVtZW50U3VtbWFyeVJlc3BvbnNlEngKGURvd25sb2FkSmVweFNldHRsZW1lbnRQZGYSLC5iZmZ1c2VyLnYxLkRvd25sb2FkSmVweFNldHRsZW1lbnRQZGZSZXF1ZXN0Gi0uYmZmdXNlci52MS5Eb3dubG9hZEplcHhTZXR0bGVtZW50UGRmUmVzcG9uc2VCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bffuser_v1_bidding_common_model, file_bffuser_v1_jepx_settlement_model, file_buf_validate_validate, file_google_type_date]);

/**
 * @generated from message bffuser.v1.ListJepxSettlementsRequest
 */
export type ListJepxSettlementsRequest = Message<"bffuser.v1.ListJepxSettlementsRequest"> & {
  /**
   * 取得する市場 (必須)。 スポットの一覧には間接送電権・定額制の清算書も含まれる。
   *
   * @generated from field: bffuser.v1.BiddingBidMarket market = 1;
   */
  market: BiddingBidMarket;

  /**
   * 清算日の期間の開始日 (含む)。 未指定は下限なし。
   *
   * @generated from field: google.type.Date settlement_date_from = 2;
   */
  settlementDateFrom?: Date;

  /**
   * 清算日の期間の終了日 (含む)。 未指定は上限なし。
   *
   * @generated from field: google.type.Date settlement_date_to = 3;
   */
  settlementDateTo?: Date;
};

/**
 * Describes the message bffuser.v1.ListJepxSettlementsRequest.
 * Use `create(ListJepxSettlementsRequestSchema)` to create a new message.
 */
export const ListJepxSettlementsRequestSchema: GenMessage<ListJepxSettlementsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_jepx_settlement_service, 0);

/**
 * @generated from message bffuser.v1.ListJepxSettlementsResponse
 */
export type ListJepxSettlementsResponse = Message<"bffuser.v1.ListJepxSettlementsResponse"> & {
  /**
   * false = 組織の JEPX 会員情報が未設定 (settlements は空)。
   *
   * @generated from field: bool jepx_member_registered = 1;
   */
  jepxMemberRegistered: boolean;

  /**
   * 条件に合う清算書の全件。 清算日の降順、 同じ清算日は清算番号の降順。
   *
   * @generated from field: repeated bffuser.v1.JepxSettlement settlements = 2;
   */
  settlements: JepxSettlement[];
};

/**
 * Describes the message bffuser.v1.ListJepxSettlementsResponse.
 * Use `create(ListJepxSettlementsResponseSchema)` to create a new message.
 */
export const ListJepxSettlementsResponseSchema: GenMessage<ListJepxSettlementsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_jepx_settlement_service, 1);

/**
 * @generated from message bffuser.v1.GetJepxSettlementSummaryRequest
 */
export type GetJepxSettlementSummaryRequest = Message<"bffuser.v1.GetJepxSettlementSummaryRequest"> & {
  /**
   * 清算書が属する市場 (必須)。 間接送電権・定額制の清算書はスポット。
   *
   * @generated from field: bffuser.v1.BiddingBidMarket market = 1;
   */
  market: BiddingBidMarket;

  /**
   * JEPX が採番した清算番号。 market と組で清算書を識別する。
   *
   * @generated from field: string settlement_number = 2;
   */
  settlementNumber: string;
};

/**
 * Describes the message bffuser.v1.GetJepxSettlementSummaryRequest.
 * Use `create(GetJepxSettlementSummaryRequestSchema)` to create a new message.
 */
export const GetJepxSettlementSummaryRequestSchema: GenMessage<GetJepxSettlementSummaryRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_jepx_settlement_service, 2);

/**
 * @generated from message bffuser.v1.GetJepxSettlementSummaryResponse
 */
export type GetJepxSettlementSummaryResponse = Message<"bffuser.v1.GetJepxSettlementSummaryResponse"> & {
  /**
   * @generated from field: bffuser.v1.JepxSettlementSummary summary = 1;
   */
  summary?: JepxSettlementSummary;
};

/**
 * Describes the message bffuser.v1.GetJepxSettlementSummaryResponse.
 * Use `create(GetJepxSettlementSummaryResponseSchema)` to create a new message.
 */
export const GetJepxSettlementSummaryResponseSchema: GenMessage<GetJepxSettlementSummaryResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_jepx_settlement_service, 3);

/**
 * @generated from message bffuser.v1.DownloadJepxSettlementPdfRequest
 */
export type DownloadJepxSettlementPdfRequest = Message<"bffuser.v1.DownloadJepxSettlementPdfRequest"> & {
  /**
   * 清算書が属する市場 (必須)。
   *
   * @generated from field: bffuser.v1.BiddingBidMarket market = 1;
   */
  market: BiddingBidMarket;

  /**
   * JEPX が採番した清算番号。 market と組で清算書を識別する。
   *
   * @generated from field: string settlement_number = 2;
   */
  settlementNumber: string;
};

/**
 * Describes the message bffuser.v1.DownloadJepxSettlementPdfRequest.
 * Use `create(DownloadJepxSettlementPdfRequestSchema)` to create a new message.
 */
export const DownloadJepxSettlementPdfRequestSchema: GenMessage<DownloadJepxSettlementPdfRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_jepx_settlement_service, 4);

/**
 * @generated from message bffuser.v1.DownloadJepxSettlementPdfResponse
 */
export type DownloadJepxSettlementPdfResponse = Message<"bffuser.v1.DownloadJepxSettlementPdfResponse"> & {
  /**
   * JEPX が発行した PDF の本文 (作り直さない)。
   *
   * @generated from field: bytes content = 1;
   */
  content: Uint8Array;
};

/**
 * Describes the message bffuser.v1.DownloadJepxSettlementPdfResponse.
 * Use `create(DownloadJepxSettlementPdfResponseSchema)` to create a new message.
 */
export const DownloadJepxSettlementPdfResponseSchema: GenMessage<DownloadJepxSettlementPdfResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_jepx_settlement_service, 5);

/**
 * JepxSettlementService exposes the 清算書 JEPX issued to the organization to
 * the frontend (docs/specs/bidding/jepx-settlement.md)。 Thin pass-through over
 * internalapi.v1.JepxSettlementService. 閲覧専用。
 *
 * @generated from service bffuser.v1.JepxSettlementService
 */
export const JepxSettlementService: GenService<{
  /**
   * ListJepxSettlements returns the 清算書 of one market, newest 清算日 first.
   * 全件を返し、 ページ送りの引数は無い。 JEPX 会員ID が未設定の組織は
   * jepx_member_registered = false と空の一覧 (AC-JST-004)。
   *
   * @generated from rpc bffuser.v1.JepxSettlementService.ListJepxSettlements
   */
  listJepxSettlements: {
    methodKind: "unary";
    input: typeof ListJepxSettlementsRequestSchema;
    output: typeof ListJepxSettlementsResponseSchema;
  },
  /**
   * GetJepxSettlementSummary returns one 清算書's 見出し and 明細 (AC-JST-007 の
   * CSV の元)。 件名は JEPX の原文、 金額は JEPX の符号のまま (負 = 会員が支払う)。
   * 組織は session から決まり、 request に載せない。
   *
   * @generated from rpc bffuser.v1.JepxSettlementService.GetJepxSettlementSummary
   */
  getJepxSettlementSummary: {
    methodKind: "unary";
    input: typeof GetJepxSettlementSummaryRequestSchema;
    output: typeof GetJepxSettlementSummaryResponseSchema;
  },
  /**
   * DownloadJepxSettlementPdf returns the 清算書 PDF JEPX issued, byte for byte
   * (AC-JST-006)。 組織は session から決まり、 request に載せない。
   *
   * @generated from rpc bffuser.v1.JepxSettlementService.DownloadJepxSettlementPdf
   */
  downloadJepxSettlementPdf: {
    methodKind: "unary";
    input: typeof DownloadJepxSettlementPdfRequestSchema;
    output: typeof DownloadJepxSettlementPdfResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_jepx_settlement_service, 0);

